

























































import { Component, Prop, Vue } from "vue-property-decorator";
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";
import CustomInput from "@/commonComponents/customInput/customInput.vue";
import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import * as def from "@/definitions";
import { ImageCategory } from "@/data/imageCategory/imageCategory"
import { Image } from "@/data/image/image"

import UnDraggableTree from "./unDraggableTree/unDraggableTree.vue"

import ImageItem from "./imageItem/imageItem.vue";

import SelectFile from "../resources/selectFile.vue";

@Component({
  components: {
    DropdownList,
    CustomInput,
    ValueEdit,
    // SlVueTree,
    ImageItem,
    SelectFile,
    UnDraggableTree
  }
})
export default class SelectImage extends Vue
{
    private selectedImage?: Image;
    // nullableだとtemplateで扱えない？imageを直接参照する代わり。
    private selectedImageId: number | string = -1;

    get rootData(): def.Data
    {
        return this.$store.getters.data;
    }

    get imageList() : def.Image[]
    {
        return this.rootData.imageList;
    }

    get selectedImageCategory()
    {
        return this.rootData.selectedImageCategory;
    }

    get imageCategoryList()
    {
        return this.rootData.imageCategoryList;
    }

    onSelectImage(image: Image)
    {
        this.selectedImage = image;
        this.selectedImageId = image.id;
    }

    onSelectImageCategory()
    {
        // イメージカテゴリの選択イベント
        this.resetScroll();
    }

    fileOpen()
    {
        this.$emit("onClickInsertObjectButton" , "image");
    }

    onOk()
    {
        if (this.selectedImage) {
            this.$emit("onOk", this.selectedImage);
        }
        this.$emit("close")
    }

    // スクロールのリセット
    private resetScroll()
    {
        try
        {
            var view = this.$refs["image-area"] as HTMLDivElement;
            view.scrollTop = 0;
        }
        catch(e)
        {
            //
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
}
